module.exports = __webpack_public_path__ + "img/collection-memoireRingsGold@2x.aec9731.webp";